// extracted by mini-css-extract-plugin
var _1 = "ra-zoom-area";
var _2 = "ra-zoom-area-visible";
var _3 = "1px";
var _4 = "ra-zoom";
var _5 = "ra-zoom-container";
var _6 = "ra-zoom-container-disable";
var _7 = "ra-zoom-container-zoomed";
var _8 = "ra-zoom-large-image-container";
var _9 = "ra-zoom-large-img";
var _a = "ra-zoom-large-img-visible";
var _b = "ra-zoom-map";
var _c = "ra-zoom-map-image";
var _d = "ra-zoom-map-inner";
var _e = "10";
var _f = "ra-zoom-map-visible";
var _10 = "ra-zoom-map-mask";
var _11 = "ra-zoom-small-img";
export { _1 as "zoomAreaCls", _2 as "zoomAreaVisibleCls", _3 as "zoomBorderSize", _4 as "zoomCls", _5 as "zoomContainerCls", _6 as "zoomContainerDisableCls", _7 as "zoomContainerZoomedCls", _8 as "zoomLargeImageContainerCls", _9 as "zoomLargeImgCls", _a as "zoomLargeImgVisibleCls", _b as "zoomMapCls", _c as "zoomMapImageCls", _d as "zoomMapInnerCls", _e as "zoomMapOffset", _f as "zoomMapVisibleCls", _10 as "zoomSVGMaskCls", _11 as "zoomSmallImgCls" }
